import { type ReactNode } from 'react'
import { cn } from '@/lib/utils'

export type PillTone = 'neutral' | 'primary' | 'dark' | 'success' | 'danger'

const TONES: Record<PillTone, string> = {
  neutral: 'bg-surfaceAlt text-ink-soft',
  primary: 'bg-primary text-primary-ink',
  dark: 'bg-ink text-surface',
  success: 'bg-success/15 text-success',
  danger: 'bg-danger/15 text-danger',
}

export function Pill({
  children,
  tone = 'neutral',
  mono = false,
  className,
}: {
  children: ReactNode
  tone?: PillTone
  mono?: boolean
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-pill px-2.5 py-1 text-xs font-semibold',
        mono && 'font-mono',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}
